import { useEffect, useState } from "react";

const navLinks = [
  { label: "风口浪尖", href: "#trending" },
  { label: "话题墙", href: "#topics" },
  { label: "翻车榜单", href: "#ranking" },
  { label: "人物档案", href: "#profiles" },
  { label: "塌房时间线", href: "#timeline" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[68px] max-w-[1200px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <span className="font-[number] text-lg leading-none">69</span>
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-bold tracking-wide text-foreground-950">黑料</span>
            <span className="text-[10px] tracking-[0.2em] text-foreground-500">人物 · 事件盘点</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#ranking"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-100 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-200 cursor-pointer sm:flex"
          >
            <i className="ri-fire-line text-primary-500 text-base" />
            本周名单
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="菜单"
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 md:hidden cursor-pointer"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pb-4 pt-2 backdrop-blur md:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 cursor-pointer"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}